import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, message } from 'antd';
import adminApi from '../../admin/config/adminApi';



const Currencies = () => {
    const [currencies, setCurrencies] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [editingCurrency, setEditingCurrency] = useState(null);
    const [search, setSearch] = useState('');

    useEffect(() => {
        fetchCurrencies();
    }, [search]);

    const fetchCurrencies = async () => {
        setLoading(true);
        try {
            const res = await adminApi.get('/currencies', { params: { search } });
            setCurrencies(res.data.currencies || []);
        } catch (error) {
            message.error('Failed to fetch currencies');
        } finally {
            setLoading(false);
        }
    };

    const showModal = (currency = null) => {
        setEditingCurrency(currency);
        if (currency) form.setFieldsValue(currency);
        else form.resetFields();
        setIsModalVisible(true);
    };

    const handleOk = async (values) => {
        try {
            if (editingCurrency) {
                await adminApi.put(`/currencies/update/${editingCurrency.id}`, values);
                message.success('Currency updated');
            } else {
                await adminApi.post('/currencies/register', values);
                message.success('Currency added');
            }
            fetchCurrencies();
            setIsModalVisible(false);
            form.resetFields();
        } catch (error) {
            console.error(error);
            message.error('Failed to save currency');
        }
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        form.resetFields();
    };

    const columns = [
        { title: 'Code', dataIndex: 'code', key: 'code' },
        { title: 'Name', dataIndex: 'name', key: 'name' },
        { title: 'Symbol', dataIndex: 'symbol', key: 'symbol' },
        {
            title: 'Action',
            key: 'action',
            render: (_, currency) => <Button onClick={() => showModal(currency)}>Edit</Button>,
        },
    ];

    return (
        <div>
            <Input
                placeholder="Search currency"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{ marginBottom: 16 }}
                allowClear
            />

            <div style={{ textAlign: 'right', marginBottom: 16 }}>
                <Button type="primary" onClick={() => showModal()}>
                    Add Currency
                </Button>
            </div>

            <Table
                columns={columns}
                dataSource={currencies}
                rowKey="id"
                loading={loading}
                pagination={{ pageSize: 50 }}
                scroll={{ x: 'max-content' }}
                style={{ maxWidth: '100%' }}
            />

            <Modal
                title={editingCurrency ? 'Edit Currency' : 'Add Currency'}
                visible={isModalVisible}
                onOk={() => form.submit()}
                onCancel={handleCancel}
                destroyOnClose
            >
                <Form form={form} layout="vertical" onFinish={handleOk}>
                    <Form.Item name="code" label="Code" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="name" label="Name" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item name="symbol" label="Symbol" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default Currencies;
